import React, { useState } from 'react';
import Input from '../Input/Input';
import Button from '../Button/Button';

export default function Form(props) {
  return (
    <div data-element="fields" data-stacked="false" className="tw:p-4 tw:flex tw:items-center tw:w-full tw:max-w-md tw:mb-3 tw:seva-fields tw:formkit-fields">
      <div className="tw:relative tw:w-full tw:mr-3 tw:formkit-field">
        <Input placeholder="Type something..." />
      </div>
      <Button classes='tw:bg-blue-800 tw:hover:bg-blue-300 tw:cursor-pointer'>Subscribe</Button>
    </div>
  );
};
